import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificarErrorGlobal } from './notificaciones-globales.js';
import { Cargando } from './piezas.js';

/**
 * Destino de las rutas que no existen para el usuario (no tiene el permiso o
 * la URL no es válida). Avisa qué pasó y lleva a `destino` sin dejar esta
 * entrada en el historial, para que «atrás» no vuelva a caer aquí.
 */
export function RutaNoDisponible({ destino }: { destino: string }): JSX.Element {
  const navegar = useNavigate();
  useEffect(() => {
    notificarErrorGlobal('Esa pantalla no existe o no tiene permiso para abrirla.');
    navegar(destino, { replace: true });
  }, [destino, navegar]);
  return <Cargando />;
}
